import { BaseTeachingElement } from "./BaseTeachingElement";

export interface ActionButtonModel {

    text?: string;

    content?: Node;

    className: string;

    clicked(): void;

}

export class ActionButtonElement
    extends BaseTeachingElement {

    private readonly model: ActionButtonModel;

    constructor(
        model: ActionButtonModel
    ) {

        super();

        this.model = model;

    }

    public override mount(): void {

        this.root =
            document.createElement(
                "button"
            );

        this.root.className =
            this.model.className;

        if (this.model.content) {

            this.root.appendChild(
                this.model.content
            );

        } else {

            this.root.textContent =
                this.model.text ?? "";

        }

        this.root.addEventListener(
            "click",
            () => {

                this.model.clicked();

            }
        );

    }

}